// Main application entry point
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import { LanguageProvider, useLanguage } from "./contexts/LanguageContext";
import { getTranslation } from "./translations/translations";
import Header from "./components/Header";
import Home from "./components/Home/Home";
import Resume from "./RenatoDelboni0826.pdf";
import Js30 from "./components/JS30/Javascript30";
import Projects from "./components/Projects/Projects";
import AboutMe from "./components/AboutMe";
import MiniProjects from "./components/MiniProjects/MiniProjects";
import ProjectDetailPage from "./components/Projects/ProjectDetailPage";
import Tests from "./components/Tests/Tests";

function AppContent() {
  const { language } = useLanguage();

  const activateFinished = () => {
    let run = document.querySelector(".run");
    let done = document.querySelector(".done");
    if (run && done) {
      run.style.display = "none";
      done.style.display = "flex";
    }
  };

  return (
    <div className="App">
      <Router>
        <Header />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/projects/:path" element={<ProjectDetailPage />} />
          <Route exact path="/mini-projects" element={<MiniProjects />} />
          <Route exact path="/projects" element={<Projects />} />
          <Route exact path="/tests" element={<Tests />} />
          <Route exact path="/javascript30" element={<Js30 />} />
          <Route
            exact
            path="/aboutme"
            element={
              <AboutMe
                title=""
                leftBtnText={
                  <a
                    href={Resume}
                    alt={getTranslation(language, "aboutMe.downloadResume")}
                    onClick={activateFinished}
                    download
                  >
                    {getTranslation(language, "aboutMe.downloadResume")}
                  </a>
                }
              />
            }
          />
        </Routes>
      </Router>
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  );
}

export default App;
